// import { GoogleGenerativeAI } from "@google/generative-ai";
import { GoogleGenAI } from "@google/genai";
// console.log("ENV KEY:", process.env.REACT_APP_GEMINI_API_KEY);
const genAI = new GoogleGenAI({
  apiKey: process.env.REACT_APP_GEMINI_API_KEY,
});

/**
 * Generate horoscope using Gemini API
 * @param {string} zodiacSign - The zodiac sign name
 * @param {string} timeframe - "TODAY", "THIS MONTH", or "THIS YEAR"
 * @returns {Promise<Object>} Horoscope object with prediction, lucky number, lucky color, vibe
 */

// -------------------------------------------------
// export const generateHoroscope = async (zodiacSign, timeframe = "TODAY") => {
//   if (!process.env.REACT_APP_GEMINI_API_KEY) {
//     throw new Error("Gemini API key is not configured");
//   }

//   try {
//     // const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });
//     const model = genAI.getGenerativeModel({
//   model: "models/gemini-1.5-flash"
// });

//     const prompt = `You are WTFHoroscope - brutally honest, savage but funny astrologer. Generate a horoscope for ${zodiacSign} for ${timeframe}.

// Rules:
// - Savage, funny, brutally honest but NOT offensive or mean
// - Gen Z language and humor (use words like "no cap", "fr fr", "bet", "slay", "it's giving", etc.)
// - Specific funny predictions (not generic)
// - 3-4 sentences max for the main prediction
// - End with a savage one-liner
// - Format the response EXACTLY like this:

// PREDICTION_TITLE: [A funny, catchy title for the prediction]
// PREDICTION: [3-4 sentences of brutal horoscope]
// LUCKY_NUMBER: [single digit 1-9]
// LUCKY_COLOR: [a color name]
// VIBE: [one emoji] [one word vibe]

// Remember: NO sugarcoating, NO fake positivity. Be hilarious and brutally honest!`;

//     const result = await model.generateContent(prompt);
//     const responseText = result.response.text();

//     // Parse the response
//     const parsed = parseHoroscopeResponse(responseText);
//     return parsed;
//   } catch (error) {
//     console.error("Gemini API Error:", error);
//     throw new Error("The stars are drunk right now. Try again in a moment 🌟");
//   }
// };


/**
 * Generate horoscope with name and profession
 * @param {string} name - User's name
 * @param {string} zodiacSign - The zodiac sign name
 * @param {string} profession - User's profession (or "general")
 * @param {string} timeframe - "TODAY", "THIS MONTH", or "THIS YEAR"
 * @returns {Promise<Object>} Horoscope object with bullet points, lucky number, color, vibe
 */
export const generateHoroscopeWithProfile = async (
  name = "bestie",
  zodiacSign,
  profession = "general",
  timeframe = "TODAY"
) => {
  if (!process.env.REACT_APP_GEMINI_API_KEY) {
    throw new Error("Gemini API key is not configured");
  }

  try {
    const prompt = `You are WTFHoroscope - brutally honest savage funny astrologer.
Generate horoscope for:
- Name: ${name}
- Zodiac Sign: ${zodiacSign}  
- Profession: ${profession}
- Period: ${timeframe}

Output EXACTLY 5 bullet points (STRICTLY follow this format):
- [FUNNY POINT 1] — savage/humor based on zodiac + profession + mention "${name}"
- [FUNNY POINT 2] — relatable Gen Z humor
- [REAL POINT 1] — actual useful/real prediction for their sign
- [REAL POINT 2] — real advice based on profession if not "general", else real zodiac advice
- [REAL POINT 3] — real prediction about love/money/energy

Then add:

Cosmic Verdict: [one savage closing line mentioning ${name}]
Lucky Number: [number 1-9]
Lucky Color: [color name]
Vibe Check: [emoji] [one word]

CRITICAL RULES:
- EXACTLY 5 bullet points - NO MORE, NO LESS
- Each point max 20 words
- Punchy, specific, NOT generic
- Mention "${name}" at least once in bullets
- Gen Z language (no cap, fr fr, bet, slay, it's giving)
- Savage but not offensive
- First point must be funny and mention ${name}
- If profession is not "general": make 1 funny and 1 real point profession-specific`;

    const result = await genAI.models.generateContent({
      model: "models/gemini-2.5-flash", // ← use your working model
      contents: prompt,
    });

    const responseText = result.text;

    const parsed = parseHoroscopeWithProfileResponse(responseText);
    return parsed;

  } catch (error) {
    console.error("Gemini API Error:", error);
    throw new Error("The stars are drunk right now. Try again in a moment 🌟");
  }
};
/**
 * Parse Gemini API response with new bullet point format
 * @param {string} responseText - Raw response from Gemini API
 * @returns {Object} Parsed horoscope object with bullet points
 */
const parseHoroscopeWithProfileResponse = (responseText) => {
  const lines = responseText.split("\n").map((line) => line.trim()).filter(line => line);

  const bulletPoints = [];
  let cosmicVerdict = "The stars have spoken 💀";
  let luckyNumber = Math.floor(Math.random() * 9) + 1;
  let luckyColor = "#7C3AED";
  let vibe = "✨ Chaotic";

  for (const line of lines) {
    if (line.startsWith("- ")) {
      // Extract bullet point (remove leading "- ")
      bulletPoints.push(line.substring(2));
    } else if (line.startsWith("Cosmic Verdict:")) {
      cosmicVerdict = line.replace("Cosmic Verdict:", "").trim();
    } else if (line.startsWith("Lucky Number:")) {
      const num = parseInt(line.replace("Lucky Number:", "").trim());
      if (!isNaN(num) && num >= 1 && num <= 9) {
        luckyNumber = num;
      }
    } else if (line.startsWith("Lucky Color:")) {
      luckyColor = line.replace("Lucky Color:", "").trim();
    } else if (line.startsWith("Vibe Check:")) {
      vibe = line.replace("Vibe Check:", "").trim();
    }
  }

  // Ensure we have exactly 5 bullet points
  while (bulletPoints.length < 5) {
    bulletPoints.push("The universe remains mysterious 🌌");
  }

  return {
    bulletPoints: bulletPoints.slice(0, 5),
    cosmicVerdict,
    luckyNumber,
    luckyColor,
    vibe,
  };
};

/**
 * Parse Gemini API response
 * @param {string} responseText - Raw response from Gemini API
 * @returns {Object} Parsed horoscope object
 */
const parseHoroscopeResponse = (responseText) => {
  const lines = responseText.split("\n").map((line) => line.trim());

  let title = "Your Cosmic Verdict";
  let prediction = "The universe has spoken... or did it?";
  let luckyNumber = Math.floor(Math.random() * 9) + 1;
  let luckyColor = "#7C3AED";
  let vibe = "✨ Chaotic";

  for (let line of lines) {
    if (line.startsWith("PREDICTION_TITLE:")) {
      title = line.replace("PREDICTION_TITLE:", "").trim();
    } else if (line.startsWith("PREDICTION:")) {
      prediction = line.replace("PREDICTION:", "").trim();
    } else if (line.startsWith("LUCKY_NUMBER:")) {
      const num = parseInt(line.replace("LUCKY_NUMBER:", "").trim());
      if (!isNaN(num) && num >= 1 && num <= 9) {
        luckyNumber = num;
      }
    } else if (line.startsWith("LUCKY_COLOR:")) {
      luckyColor = line.replace("LUCKY_COLOR:", "").trim();
    } else if (line.startsWith("VIBE:")) {
      vibe = line.replace("VIBE:", "").trim();
    }
  }

  return {
    title,
    prediction,
    luckyNumber,
    luckyColor,
    vibe,
  };
};

/**
 * Get cached horoscope from localStorage
 * @param {string} key - Cache key
 * @returns {Object|null} Cached horoscope or null if expired or not found
 */
export const getCachedHoroscope = (key) => {
  try {
    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const data = JSON.parse(cached);

    // Check if cache is still valid (same day)
    const cacheDate = new Date(data.date).toDateString();
    const today = new Date().toDateString();

    if (cacheDate === today) {
      return data.horoscope;
    }
  } catch (error) {
    console.error("Cache retrieval error:", error);
  }

  return null;
};

/**
 * Cache horoscope in localStorage
 * @param {string} key - Cache key
 * @param {Object} horoscope - Horoscope object to cache
 */
export const cacheHoroscope = (key, horoscope) => {
  try {
    const data = {
      horoscope,
      date: new Date().toISOString(),
    };
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error("Cache storage error:", error);
  }
};
